import React from "react";
import HeaderBox from "./header/HeaderBox";
import Slider from "./Slider";
import Services from "./Services";
import Forms from "./Contact";
import Opinions from "./Opinions";
const MainPage = () => {
  return (
    <>
      <HeaderBox />
      <Services />
      <Slider />
      <Opinions />
      <Forms />
    </>
  );
};
export default MainPage;
